import { atom } from "jotai";

import { BuiltInApp, Chatbot } from "../types";
import { atomWithRefresh } from "../utils";

export const chatbotsAppAtom = atom<BuiltInApp | null>(null);
chatbotsAppAtom.debugLabel = "chatbotsAppAtom";

export const chatbotsAtom_SUSPENDS = atomWithRefresh<Promise<Chatbot[]>>(
  async () => {
    try {
      const res = await fetch(`/api/canvasui/chatbots`);

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.errors);
      }

      return await res.json();
    } catch {
      return [];
    }
  },
);

chatbotsAtom_SUSPENDS.debugLabel = "chatbotsAtom_SUSPENDS";
